/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FxGamesLibWebRpcContractsResponse,
  FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs,
  FxIdApplicationNotificationsScheduleScheduleNotificationsArgs,
} from '../models/index';
import {
    FxGamesLibWebRpcContractsResponseFromJSON,
    FxGamesLibWebRpcContractsResponseToJSON,
    FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsFromJSON,
    FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsToJSON,
    FxIdApplicationNotificationsScheduleScheduleNotificationsArgsFromJSON,
    FxIdApplicationNotificationsScheduleScheduleNotificationsArgsToJSON,
} from '../models/index';

export interface FxIdWebFeaturesNotificationsReplaceReplaceScheduledNotificationsEndpointRequest {
    fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs: FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs;
}

export interface FxIdWebFeaturesNotificationsScheduleScheduleNotificationsEndpointRequest {
    fxIdApplicationNotificationsScheduleScheduleNotificationsArgs: FxIdApplicationNotificationsScheduleScheduleNotificationsArgs;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * **MUTATES:** `notification`  Replaces all pending notifications for the user 
     */
    async fxIdWebFeaturesNotificationsReplaceReplaceScheduledNotificationsEndpointRaw(requestParameters: FxIdWebFeaturesNotificationsReplaceReplaceScheduledNotificationsEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxGamesLibWebRpcContractsResponse>> {
        if (requestParameters['fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs'] == null) {
            throw new runtime.RequiredError(
                'fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs',
                'Required parameter "fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs" was null or undefined when calling fxIdWebFeaturesNotificationsReplaceReplaceScheduledNotificationsEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notifications/replace`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgsToJSON(requestParameters['fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `notification`  Replaces all pending notifications for the user 
     */
    async fxIdWebFeaturesNotificationsReplaceReplaceScheduledNotificationsEndpoint(fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs: FxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxGamesLibWebRpcContractsResponse> {
        const response = await this.fxIdWebFeaturesNotificationsReplaceReplaceScheduledNotificationsEndpointRaw({ fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs: fxIdApplicationNotificationsReplaceReplaceScheduledNotificationsArgs }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `notification`  Schedules push notifications for the user 
     */
    async fxIdWebFeaturesNotificationsScheduleScheduleNotificationsEndpointRaw(requestParameters: FxIdWebFeaturesNotificationsScheduleScheduleNotificationsEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxGamesLibWebRpcContractsResponse>> {
        if (requestParameters['fxIdApplicationNotificationsScheduleScheduleNotificationsArgs'] == null) {
            throw new runtime.RequiredError(
                'fxIdApplicationNotificationsScheduleScheduleNotificationsArgs',
                'Required parameter "fxIdApplicationNotificationsScheduleScheduleNotificationsArgs" was null or undefined when calling fxIdWebFeaturesNotificationsScheduleScheduleNotificationsEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/notifications/schedule`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationNotificationsScheduleScheduleNotificationsArgsToJSON(requestParameters['fxIdApplicationNotificationsScheduleScheduleNotificationsArgs']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `notification`  Schedules push notifications for the user 
     */
    async fxIdWebFeaturesNotificationsScheduleScheduleNotificationsEndpoint(fxIdApplicationNotificationsScheduleScheduleNotificationsArgs: FxIdApplicationNotificationsScheduleScheduleNotificationsArgs, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxGamesLibWebRpcContractsResponse> {
        const response = await this.fxIdWebFeaturesNotificationsScheduleScheduleNotificationsEndpointRaw({ fxIdApplicationNotificationsScheduleScheduleNotificationsArgs: fxIdApplicationNotificationsScheduleScheduleNotificationsArgs }, initOverrides);
        return await response.value();
    }

}
